import { Search, Suggestion } from "@/services/api/sdk";

export function groupSuggestionsByFieldId(suggestions: Suggestion[]): Record<number, Suggestion[]> {
    return suggestions.reduce((suggestions, suggestion) => {
        // find an existing suggestion with the same group and display name
        const duplicateSuggestion = Object.values(suggestions).some(
            (s) => {
                return s.some(
                    (_suggestion) =>
                        _suggestion.fieldId === suggestion.fieldId &&
                        _suggestion.value?.valueString === suggestion.value?.valueString &&
                        _suggestion.value?.valueNumber === suggestion.value?.valueNumber,
                );
            },
        );

        if (duplicateSuggestion) {
            return suggestions;
        }

        suggestions[suggestion.fieldId!] = [
            ...(suggestions[suggestion.fieldId!]
                ? suggestions[suggestion.fieldId!]
                : []),
            suggestion,
        ].sort((a, b) => {
            return a.score! > b.score! ? -1 : 1;
        });

        return suggestions;
    }, {} as Record<number, Suggestion[]>);
}

export function groupSearchesByFieldId(searches: Search[]): Record<number, Search[]> {
    return searches.reduce((acc, search) => {
        // find an existing suggestion with the same group and display name
        const duplicateSearch = Object.values(acc).some(
            (s) => {
                return s.some(
                    (_suggestion) =>
                        _suggestion.fieldId === search.fieldId &&
                        _suggestion.query === search.query
                );
            },
        );

        if (duplicateSearch) {
            return acc;
        }

        if (!acc[search.fieldId!]) {
            acc[search.fieldId!] = [];
        }

        acc[search.fieldId!].push(search);

        return acc;
    }, {} as Record<number, Search[]>);
}


export function isNonEmptySuggestion(suggestion: Suggestion): boolean {
    return suggestion.value?.valueBoolean != null || !!suggestion.value?.valueString || suggestion.value?.valueNumber != null;
}